import { render } from "./WinnersView.vue?vue&type=template&id=72e218a2&lang=html"
import script from "./WinnersView.vue?vue&type=script&lang=js"
export * from "./WinnersView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Apps/sendcloudholidaygiftsraffle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__